import client from './client';
import qs from 'qs';
const menuUrl = '/api/v1/sys/menu';
const authUrl = '/api/v1/sys/auth';
//const empUrl = '/api/v1/user';

export const getListTree = async (params) => {
  const queryString = qs.stringify(params);
  const response = await client.get(`${menuUrl}/list/tree?${queryString}`);
  return response;
};

export const getListMenus = async (params) => {
  const queryString = qs.stringify(params);
  const response = await client.get(`${menuUrl}/list?${queryString}`);
  return response;
};


export const getListMenuHistorys = (params) => {
  //const queryString = qs.stringify(params);
  return client.get(`${menuUrl}/history/list/menu-uuid/${params}`);
};

export const addMenuInfo = (dataToSubmit) => {
  return client.post(`${menuUrl}/info`, dataToSubmit);
};


// export const updateMenuInfo = (dataToSubmit) => {
//   return client.post(`${menuUrl}/info`, dataToSubmit);
// };
export const editMenuInfo = (dataToSubmit) => {
  return client.put(
    `${menuUrl}/update/${dataToSubmit.menuUuid}`,
    dataToSubmit,
  );
};

export const removeMenuInfo = (id) => {
  return client.delete(`${menuUrl}/delete/${id}`);

};


export const saveAuth = async (dataToSubmit) => {
  return client.post(
    `${authUrl}/info`,
    dataToSubmit,
  );
};


export const getAuth = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${authUrl}/info?${queryString}`);
};

export const checkAuth = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${authUrl}/check/auth?${queryString}`);
};

// const saveAuth = async (dataToSubmit) => {
//   const response = await fetch('/api/menu-auth', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       authType: 'USER',
//       targetId: 'USER001',
//       menuUuids: ['menu-1', 'menu-2', 'menu-3']
//     })
//   });
//   return response.json();
// };

// // 권한 조회
// const getAuth = async () => {
//   const response = await fetch('/api/menu-auth?authType=USER&targetId=USER001');
//   return response.json(); // ['menu-1', 'menu-2', 'menu-3']
// };

// // 권한 확인
// const checkAuth = async () => {
//   const response = await fetch('/api/menu-auth/check?authType=USER&targetId=USER001&menuUuid=menu-1');
//   return response.json(); // true or false
// };
